// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- FormularAnunt.css --- */

.formular-anunt {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Două coloane pe desktop */
  gap: 24px;
  max-width: 1150px;
  margin: 0 auto;
}

/* Grupurile care ocupă toată lățimea (ex: Titlu, Descriere, Poze) */
.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.formular-anunt h2{
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
    text-shadow:
    1px 1px 0 black,
    -1px 1px 0 black,
    1px -1px 0 black,
    -1px -1px 0 black;
}

.form-group label {
  font-weight: 700;
  font-size: 0.9rem;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
  text-transform: uppercase;
  letter-spacing: 0.5px;
    font-weight: 900;
  color: #f2c94c; /* galben */
  text-shadow:
    1px 1px 0 black,
    -1px 1px 0 black,
    1px -1px 0 black,
    -1px -1px 0 black;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 16px;
  border: 1px solid #000000;
  border-radius: 12px;
  font-size: 15px;
  background-color: #f8fafc;
  transition: all 0.2s ease-in-out;
  color: #1a202c;
  outline: none;
}

/* Efect de focus cu galbenul brandului */
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #f4b400;
  background-color: #ffffff;
  box-shadow: 0 0 0 4px rgba(244, 180, 0, 0.15);
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

/* Stil pentru Input-ul de File (Upload) */
.form-group input[type="file"] {
  background: #fff;
  border: 2px dashed #cbd5e0;
  cursor: pointer;
  padding: 20px;
  text-align: center;
}

.form-group input[type="file"]:hover {
  border-color: #f4b400;
  background: rgba(244, 180, 0, 0.05);
}

/* Zona de Preview Imagini */
.preview-imagini {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding: 10px;
  background: #f1f5f9;
  border-radius: 12px;
}

.preview-imagini img {
  width: 110px;
  height: 110px;
  object-fit: cover;
  border-radius: 10px;
  border: 3px solid white;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  transition: transform 0.2s;
}

.preview-imagini img:hover {
  transform: scale(1.05);
}

/* Butonul de Submit */
.btn-submit {
  grid-column: 1 / -1; /* Ocupă tot rândul */
  margin-top: 10px;
  padding: 16px;
  background: #f4b400; /* Galbenul oficial */
  color: #000; /* Text negru pentru contrast pe galben */
  border: none;
  border-radius: 14px;
  font-size: 1.1rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(244, 180, 0, 0.4);
  transition: all 0.3s ease;
}

.btn-submit:hover {
  background: #d8a000;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(244, 180, 0, 0.5);
}

.btn-submit:active {
  transform: translateY(0);
}

.btn-submit:disabled {
  background: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* --- Responsive pentru Formular --- */
@media (max-width: 650px) {
  .formular-anunt {
    grid-template-columns: 1fr; /* O singură coloană pe mobil */
    gap: 16px;
  }
  
  .btn-submit {
    font-size: 1rem;
    padding: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FormularAnunt.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,aAAa;EACb,8BAA8B,EAAE,4BAA4B;EAC5D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,cAAc,EAAE,WAAW;IACzB;;;;qBAIiB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B,yBAAyB;EACzB,qBAAqB;IACnB,gBAAgB;EAClB,cAAc,EAAE,WAAW;EAC3B;;;;qBAImB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,aAAa;AACf;;AAEA,yCAAyC;AACzC;;;EAGE,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB,EAAE,qBAAqB;EAC1C,WAAW,EAAE,yCAAyC;EACtD,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE;IACE,0BAA0B,EAAE,+BAA+B;IAC3D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":["/* --- FormularAnunt.css --- */\n\n.formular-anunt {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Două coloane pe desktop */\n  gap: 24px;\n  max-width: 1150px;\n  margin: 0 auto;\n}\n\n/* Grupurile care ocupă toată lățimea (ex: Titlu, Descriere, Poze) */\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.formular-anunt h2{\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n    text-shadow:\n    1px 1px 0 black,\n    -1px 1px 0 black,\n    1px -1px 0 black,\n    -1px -1px 0 black;\n}\n\n.form-group label {\n  font-weight: 700;\n  font-size: 0.9rem;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n    font-weight: 900;\n  color: #f2c94c; /* galben */\n  text-shadow:\n    1px 1px 0 black,\n    -1px 1px 0 black,\n    1px -1px 0 black,\n    -1px -1px 0 black;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 12px 16px;\n  border: 1px solid #000000;\n  border-radius: 12px;\n  font-size: 15px;\n  background-color: #f8fafc;\n  transition: all 0.2s ease-in-out;\n  color: #1a202c;\n  outline: none;\n}\n\n/* Efect de focus cu galbenul brandului */\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  border-color: #f4b400;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 4px rgba(244, 180, 0, 0.15);\n}\n\n.form-group textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n/* Stil pentru Input-ul de File (Upload) */\n.form-group input[type=\"file\"] {\n  background: #fff;\n  border: 2px dashed #cbd5e0;\n  cursor: pointer;\n  padding: 20px;\n  text-align: center;\n}\n\n.form-group input[type=\"file\"]:hover {\n  border-color: #f4b400;\n  background: rgba(244, 180, 0, 0.05);\n}\n\n/* Zona de Preview Imagini */\n.preview-imagini {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n  padding: 10px;\n  background: #f1f5f9;\n  border-radius: 12px;\n}\n\n.preview-imagini img {\n  width: 110px;\n  height: 110px;\n  object-fit: cover;\n  border-radius: 10px;\n  border: 3px solid white;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  transition: transform 0.2s;\n}\n\n.preview-imagini img:hover {\n  transform: scale(1.05);\n}\n\n/* Butonul de Submit */\n.btn-submit {\n  grid-column: 1 / -1; /* Ocupă tot rândul */\n  margin-top: 10px;\n  padding: 16px;\n  background: #f4b400; /* Galbenul oficial */\n  color: #000; /* Text negru pentru contrast pe galben */\n  border: none;\n  border-radius: 14px;\n  font-size: 1.1rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(244, 180, 0, 0.4);\n  transition: all 0.3s ease;\n}\n\n.btn-submit:hover {\n  background: #d8a000;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(244, 180, 0, 0.5);\n}\n\n.btn-submit:active {\n  transform: translateY(0);\n}\n\n.btn-submit:disabled {\n  background: #e2e8f0;\n  color: #94a3b8;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* --- Responsive pentru Formular --- */\n@media (max-width: 650px) {\n  .formular-anunt {\n    grid-template-columns: 1fr; /* O singură coloană pe mobil */\n    gap: 16px;\n  }\n  \n  .btn-submit {\n    font-size: 1rem;\n    padding: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
